import * as React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { TableFooter } from "@mui/material";
import { Loader } from "../elements/Loader";
import { Button, Tag } from "antd";
import { DEFAULT_LIMIT } from "../../constants/webapp";
import { stringfy } from "../../utils/helpers";

function Row(props) {
  const { row, columns } = props;
  const [open, setOpen] = React.useState(false);
  const component = row.component;

  return (
    <React.Fragment>
      <TableRow
        sx={{
          "& > *": { borderBottom: "unset" },
          // "&:last-child td, &:last-child th": { border: 0 },
          cursor: "pointer",
        }}
        hover
      >
        {component && (
          <TableCell>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>
        )}

        {/* Map from column keys to Table cells */}
        {columns.map((column, i) => (
          <TableCell
            onClick={i === 0 ? row.onclick : null}
            align={column.align || "right"}
            key={i}
            sx={{ fontSize: 13, minWidth: i === 0 && 200 }}
          >
            {row[column.id]}
          </TableCell>
        ))}
      </TableRow>

      {component && (
        <TableRow>
          <TableCell style={{ padding: 0 }} colSpan={10}>
            <Collapse
              in={open}
              timeout="auto"
              mountOnEnter
              sx={{ bgcolor: "#f9f9f9" }}
            >
              <Box sx={{ margin: 0 }}>{component}</Box>
            </Collapse>
          </TableCell>
        </TableRow>
      )}
    </React.Fragment>
  );
}

export default function CollapseTable({
  columns,
  rows = [],
  loading,
  expandable = false,
  fetchMore,
}) {
  return (
    <TableContainer
      sx={{
        backgroundColor: "white",
        mb: 4,
        mt: 2,
        border: "1px solid #ccc",
        borderRadius: 3,
        maxHeight: "calc(100vh - 185px)",
      }}
    >
      <Table size="small" stickyHeader>
        <TableHead>
          <TableRow sx={{ whiteSpace: "nowrap" }}>
            {expandable && <TableCell width={10} />}
            {/* loop row cells */}
            {columns?.map((column, i) => {
              const { align, title, id, tag } = column;
              return (
                <TableCell align={align || "right"} key={i}>
                  <p className="font14 capitalize">
                    {title || stringfy(id)}
                    {tag && (
                      <span>
                        <Tag className="noMargin" style={{ marginLeft: 10 }}>
                          {tag}
                        </Tag>
                      </span>
                    )}
                  </p>
                </TableCell>
              );
            })}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, i) => (
            <Row key={i} row={row} columns={columns} />
          ))}
        </TableBody>
        {rows?.length === 0 && (
          <TableFooter>
            <TableRow>
              <TableCell align="center" sx={{ p: 2 }} colSpan={10}>
                {loading ? <Loader /> : "Nothing available"}
              </TableCell>
            </TableRow>
          </TableFooter>
        )}
      </Table>

      {fetchMore && rows?.length >= DEFAULT_LIMIT && (
        <Button
          loading={loading}
          type="primary"
          onClick={fetchMore}
          style={{ margin: "10px 15px", fontSize: 13 }}
        >
          Load More +{DEFAULT_LIMIT}
        </Button>
      )}
    </TableContainer>
  );
}

CollapseTable.propTypes = {
  columns: PropTypes.array.isRequired,
  rows: PropTypes.array.isRequired,
};
